import React, { FC } from 'react';

import DeleteClub from './Components/DeleteClub';
import AboutTheClub from './Components/AboutTheClub';
import Settings from './Components/Settings';

const ClubSettingsSection: FC = () => {
  return (
    <div className="club-settings-section">
      <Settings />

      <AboutTheClub />

      <DeleteClub />
    </div>
  );
};

export default ClubSettingsSection;
